import {useContext} from "react";

import type CameraContextType from "./CameraContext";
import {CameraContext} from "./CameraProvider";

const useMyCamera = (): CameraContextType => {
  const context = useContext(CameraContext);
  if (!context) {
    throw new Error("useMyCamera must be used within a CameraProvider");
  }
  return context;
};

export default useMyCamera;
